'use client'

import classNames from 'classnames'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { ShowAtBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'
import { MediaUploadPhotoDto } from '@marketplace-web/item-upload/media-upload-data'
import { urlWithParams } from '@marketplace-web/shared/utils'
import { useAbTest, useTrackAbTest } from '@marketplace-web/feature-flags/ab-tests-data'

import { CREATE_BUNDLE_URL } from 'constants/routes'

import AddMoreItems from './AddMoreItems'
import Upload from './Upload'

type Props = {
  isInputExpanded: boolean
  isConversationUploadEnabled: boolean
  isSellerCountdownActive: boolean | undefined
  storeImage: (image: MediaUploadPhotoDto) => void
  onError?: (data: string | JSX.Element) => void
}

const ComposerActions = ({
  isInputExpanded,
  isConversationUploadEnabled,
  isSellerCountdownActive,
  storeImage,
  onError,
}: Props) => {
  const { conversation } = useConversationContext()

  const showBundleAction = conversation?.isBundleAvailable && !isSellerCountdownActive

  const swapppingConversationActionsPositionsABTest = useAbTest(
    'dd_tx_swapping_conversation_actions_positions',
  )
  const shouldTrackAbTest = showBundleAction && isConversationUploadEnabled
  useTrackAbTest(swapppingConversationActionsPositionsABTest, shouldTrackAbTest)

  const renderAddMoreItemsUrl = () => {
    if (!conversation?.transaction) return null

    const { id: transactionId, seller, order } = conversation.transaction

    if (!seller?.id) return null

    return urlWithParams(CREATE_BUNDLE_URL(seller.id.toString()), {
      transaction_id: transactionId,
      item_ids: order.itemIds,
    })
  }

  const renderActions = () => {
    const inputClass = classNames(
      'u-flexbox',
      'u-line-height-none',
      'u-align-items-flex-end',
      'u-ui-padding-right-large',
    )

    if (!conversation) return null

    if (swapppingConversationActionsPositionsABTest?.variant === 'a') {
      return (
        <div className={inputClass}>
          {isConversationUploadEnabled && (
            <Upload conversation={conversation} storeImage={storeImage} onError={onError} />
          )}
          {showBundleAction && <AddMoreItems addMoreItemsUrl={renderAddMoreItemsUrl()} />}
        </div>
      )
    }

    return (
      <div className={inputClass}>
        {showBundleAction && <AddMoreItems addMoreItemsUrl={renderAddMoreItemsUrl()} />}
        {isConversationUploadEnabled && (
          <Upload conversation={conversation} storeImage={storeImage} onError={onError} />
        )}
      </div>
    )
  }

  return (
    <>
      <ShowAtBreakpoint breakpoint="phones">{!isInputExpanded && renderActions()}</ShowAtBreakpoint>
      <ShowAtBreakpoint breakpoint="tabletsUp">{renderActions()}</ShowAtBreakpoint>
    </>
  )
}

export default ComposerActions
